import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { FiArrowLeft, FiTrash2 } from 'react-icons/fi';
import Select from 'react-select';
import InputMask from 'react-input-mask';
import api from '../../services/api';
import FeedLayout from '../Includes/FeedLayout';

import './styles.scss';

const SHOW_SEND_TO = false;

export default function Negocio() {
  const  { t } = useTranslation();
  const history = useHistory();
  const [kind, setkind] = useState('sale');
  const [negotiationDate, setNegotiationDate] = useState('');
  const [deliveryDate, setDeliveryDate] = useState('');
  const [tags] = useState(() => {
    try {
      const cached = JSON.parse(sessionStorage.getItem('TAGS'));
      return Array.isArray(cached) ? cached : [];
    } catch (err) {
      return [];
    }
  });
  const [tagSelected, setTagSelected] = useState({ awards: [] });
  const [negotiatedValue, setNegotiatedValue] = useState(0);
  const [paymentMeasure, setPaymentMeasure] = useState('fifteen_kilos');
  const [measureTypes] = useState([{ name: t('pages.business.options.measureTypes.fifteen_kilos'), value: 'fifteen_kilos' }, { name: t('pages.business.options.measureTypes.sacs'), value: 'sacs' }, { name: t('pages.business.options.measureTypes.tons'), value: 'tons' }, { name: t('pages.business.options.measureTypes.head'), value: 'head' }]);
  const [otherValue, setOtherValue] = useState(0);
  const [paymentForm, setPaymentForm] = useState('in_cash');
  const [awardsValues, setAwardsValues] = useState([]);
  const [fridges, setFridges] = useState([]);
  const [fridgeSelectedId, setFridgeSelectedId] = useState('');
  const [allowSlaughterHouseName, setAllowSlaughterHouseName] = useState(true);
  const [slaughterForm, setSlaughterForm] = useState('');
  const [termination, setTermination] = useState('semi_confined');
  const [taxForm, setTaxForm] = useState('to_charge');
  const [freightResponsibility, setFreightResponsibility] = useState('buyer');
  const [citys, setCitys] = useState([]);
  const [cityCode, setCityCode] = useState();
  const [infoSlaughter, setInfoSlaughter] = useState([]);
  const [draftSlaughterQty, setDraftSlaughterQty] = useState('');
  const [draftSlaughterDate, setDraftSlaughterDate] = useState('');
  const [draftSlaughterObs, setDraftSlaughterObs] = useState('');
  const [aliveKg, setAliveKg] = useState();
  const [animalsQuantity, setAnimalsQuantity] = useState('');
  const [erros, setErros] = useState([]);
  const [success, setSuccess] = useState(false);
  const [sending, setSending] = useState(false);
  const [reviewers, setReviewers] = useState([]);
  const [reviewerId, setReviewerId] = useState();
  const [isFasting, setIsFasting] = useState();
  const [hoursFasting, setHoursFasting] = useState(0);

  const [cattleBreeds, setCattleBreeds] = useState([
    { breed: 'nelore', name: t('pages.business.options.cattleBreeds.nelore'), cattle_percentage: 0 },
    { breed: 'angus', name: t('pages.business.options.cattleBreeds.angus'), cattle_percentage: 0 },
    { breed: 'other_breeds', name: t('pages.business.options.cattleBreeds.other_breeds'), cattle_percentage: 0 },
    { breed: 'no_breed', name: t('pages.business.options.cattleBreeds.no_breed'), cattle_percentage: 0 }
  ]);

  const [checkBreeds, setCheckBreeds] = useState([
    { kind: 'nelore', check: true },
    { kind: 'angus', check: false },
    { kind: 'other_breeds', check: false },
    { kind: 'no_breed', check: false }
  ]);

  const [cattleType, setCattleType] = useState([
    { cattle_type: 'castrated', type_percentage: 0 },
    { cattle_type: 'not_castrated', type_percentage: 0 }
  ]);

  const [checkCattleType, setCheckCattleType] = useState([
    { kind: 'castrated', check: true },
    { kind: 'not_castrated', check: false }
  ]);

  useEffect(() => {
    api.get('/v5/fridges/optimized_index')
      .then(response => setFridges(response.data.map(fridge => ({ value: fridge.id, label: fridge.name })))
    );
  }, []);

  useEffect(() => {
    setAwardsValues(tagSelected.awards.map((award) => ({ ...award, value: 0 })));
  }, [tagSelected.awards])
  
  useEffect(() => {
    const checked = checkBreeds.map(checked => checked.check ? 1 : 0);
    let countCheckeds = checked.reduce((a, b) => a + b, 0);

    const newCattleBreeds = cattleBreeds.map((breed, index) => {
      return checkBreeds[index].check ? { ...breed, cattle_percentage: parseInt(100 / countCheckeds) } : { ...breed, cattle_percentage: 0 };
    },[]);

    setCattleBreeds(newCattleBreeds);
  }, [checkBreeds]);

  useEffect(() => {
    const checked = checkCattleType.map(checked => checked.check ? 1 : 0);
    let countCheckeds = checked.reduce((a, b) => a + b, 0);

    const newCattleType = cattleType.map((cattleType, index) => {
      return checkCattleType[index].check ? { ...cattleType, type_percentage: parseInt(100 / countCheckeds) } : { ...cattleType, type_percentage: 0 };
    });

    setCattleType(newCattleType);
  }, [checkCattleType]);

  function handleInputChangeTags(tagId) {
    setTagSelected(tagId === "no_tag" ? { awards: [] } : (tags || []).find(tag => Number(tag.id) === Number(tagId)) || { awards: [] });
  }

  function DataSendFormat() {
    return {
      kind: kind,
      slaughter_form: slaughterForm,
      payment_form: paymentForm,
      tax_form: taxForm,
      animals_quantity: animalsQuantity,
      negotiation_date: negotiationDate,
      freight_responsibility: freightResponsibility,
      fridge_id: fridgeSelectedId,
      date: deliveryDate,
      negotiated_value: negotiatedValue,
      total_value: negotiatedValue,
      other_value: otherValue,
      payment_measure: paymentMeasure,
      tag_id: tagSelected.id,
      city_code: cityCode,
      allow_slaughter_house_name: allowSlaughterHouseName,
      termination: termination,
      alive_kg: aliveKg,
      slaughters: infoSlaughter.map(item => ({
        ...item,
        observation: draftSlaughterObs || item.observation || ''
      })),
      award_values: awardsValues.map(award => ({ award_id: award.id, value: award.value })),
      cattle_breeds: cattleBreeds.filter((breed) => Number(breed.cattle_percentage) > 0),
      cattle_types: cattleType.filter((item) => Number(item.type_percentage) > 0),
      reviwer_id: reviewerId,
      hours_fasting: isFasting ? hoursFasting : 0
    }
  }

  function handleAwardValues(awardId, value) {
    const newAwardsValues = awardsValues.map(award => award.id === parseInt(awardId) ? { ...award, value: value } : award);

    setAwardsValues(newAwardsValues);
  }

  function handleBreedsValue(kind, value) {
    const newCattleBreeds = cattleBreeds.map(cattleBreed => cattleBreed.breed === kind ? { ...cattleBreed, cattle_percentage: parseInt(value) } : cattleBreed);

    setCattleBreeds(newCattleBreeds);
  }

  function handleBreedsCheck(kind) {
    const newCheckBreeds = checkBreeds.map(breed => breed.kind === kind ? { ...breed, check: !breed.check } : breed);

    setCheckBreeds(newCheckBreeds);
  }

  function handleCattleType(kind, value) {
    const newCattleType = cattleType.map(cattle => cattle.kind === kind ? { ...cattle, value: parseInt(value) } : cattle);

    setCattleType(newCattleType);
  }

  function handleCheckCattleType(kind) {
    const newCheckBreeds = checkCattleType.map(checkCattle => checkCattle.kind === kind ? { ...checkCattle, check: !checkCattle.check } : checkCattle);

    setCheckCattleType(newCheckBreeds);
  }

  function addAbate(e) {
    if (e) e.preventDefault();
    if (!draftSlaughterQty || !draftSlaughterDate) {
      return;
    }
    setInfoSlaughter([
      ...infoSlaughter,
      {
        animals_quantity: draftSlaughterQty,
        slaughter_date: draftSlaughterDate,
        observation: draftSlaughterObs || ''
      }
    ]);
    setDraftSlaughterQty('');
    setDraftSlaughterDate('');
  }

  function removeAbate(index) {
    setInfoSlaughter(infoSlaughter.filter((_, i) => i !== index));
  }

  function formatSlaughterDate(value) {
    const raw = String(value || '');
    return raw.replace(/(\d*)-(\d*)-(\d*).*/, '$3/$2/$1');
  }

  function searchReviewer(name) {
    if (name.length >= 3) {
      api.get(`/v5/users/reviwers?name=${name}`)
        .then(response => setReviewers(response.data.map(param => ({
            value: param.id,
            label: `${param.name} (${param.nickname})`
          })))
        )
    }
  }

  function searchCityByName(name) {
    if (name.length >= 3) {
      api.get(`/v4/search/cities?term=${name}`)
        .then(response => setCitys(response.data.map(param => ({
            value: param.code,
            label: param.value
          })))
        )
    }
  }

  function calculateTotalValue() {
    let value = parseInt(negotiatedValue)+parseInt(otherValue);

    return !!value ? value : 0;
  }

  function isInvalid() {
    const newErrors = [];

    if (!tagSelected.id) {
      newErrors.push(t('pages.business.errors.selectTag'));
    }

    var countCattlePercentage = cattleBreeds.map(breed => breed.cattle_percentage).reduce((a, b) => a + b, 0);
    if (countCattlePercentage < 99) {
      newErrors.push(t('pages.business.errors.invalidPercent'));
    }

    setErros(newErrors);

    return newErrors.length > 0
  }

  function SendNegotiation(e) {
    e.preventDefault();

    if (sending) return;
    if (isInvalid()) return;

    setErros([]);
    setSuccess(false);
    setSending(true);

    api.post('/v7/users/me/negotiations', DataSendFormat())
      .then(() => {
        setErros([]);
        setSuccess(true);
        setSending(false);
        setTimeout(() => {
          history.push('/timeline');
        }, 3000);
      })
      .catch((error) => {
        const raw = error.response && error.response.data && error.response.data.errors;
        setErros(Array.isArray(raw) ? raw : [raw || t('pages.business.errors.incorrectData')]);
        setSending(false);
      });
  }

  function voltar() {
    if (history.length > 1) {
      history.goBack();
    } else {
      history.push('/negociacoes');
    }
  }

  return (
    <FeedLayout active="negotiations">
    <div className="cadastro-negocio-container">
      <div className="feed-top">
        <button type="button" className="btn-voltar" onClick={voltar}>
          <FiArrowLeft size={18} /> {t('pages.business.back')}
        </button>
        <span>{t('pages.business.title')}</span>
      </div>

      <form onSubmit={SendNegotiation}>
        <div className="field kind">
          <div className="title">
            {t('pages.business.soldBought')}
          </div>
          <div className="content">
            <label>
              <input
                type="radio"
                checked={kind === "sale"}
                onChange={() => setkind('sale')}
              />
              {t('pages.business.sold')}
            </label>
            <label>
              <input
                type="radio"
                checked={kind === "purchase"}
                onChange={() => setkind('purchase')}
              />
              {t('pages.business.bought')}
            </label>
          </div>
        </div>

        <div className="field negotiation-date">
          <div className="title">
            {t('pages.business.negociationDate')}
          </div>
          <div className="content">
            <input
              type="date"
              onChange={(e) => setNegotiationDate(e.target.value)}
            />
          </div>
        </div>

        { tagSelected.is_slaughter === false &&
          <div className="field negotiation-date">
            <div className="title">
              {t('pages.business.deliveryDate')}
            </div>
            <div className="content">
              <input
                type="date"
                onChange={(e) => setDeliveryDate(e.target.value)}
              />
            </div>
          </div>
        }

        <div className="field tag">
          <div className="title">
            {t('pages.business.negociated')}
          </div>
          <div className="content">
            <select
              onChange={ (e) => handleInputChangeTags(e.target.value) }
            >
              <option value={"no_tag"}>{t('pages.business.selectTag')}</option>
              { (tags || []).map(tag => <option key={tag.id} value={tag.id}>{tag.name}</option>) }
            </select>
          </div>
        </div>

        { tagSelected.is_slaughter &&
          <>
            <div className="field">
              <div className="title">
                {t('pages.business.slaughterPlant')}
              </div>
              <div className="content">
                <Select
                  className="select"
                  classNamePrefix="select"
                  options={fridges}
                  placeholder={t('pages.business.placeholder.select')}
                  noOptionsMessage={() => t('pages.business.placeholder.noOptions')}
                  onChange={(e) => { setFridgeSelectedId(e.value) }}
                />
              </div>
            </div>

            <div className="field">
              <div className="title">
                {t('pages.business.authorize')}
              </div>
              <div className="content">
                <label>
                  <input
                    type="radio"
                    checked={allowSlaughterHouseName}
                    onChange={() => setAllowSlaughterHouseName(true)}
                  />
                  {t('pages.business.yes')}
                </label>
                <label>
                  <input
                    type="radio"
                    checked={!allowSlaughterHouseName}
                    onChange={() => setAllowSlaughterHouseName(false)}
                  />
                  {t('pages.business.no')}
                </label>
              </div>
            </div>

            <div className="field">
              <div className="title">
                {t('pages.business.slaughterWay')}
              </div>
              <div className="content">
                <label>
                  <input
                    type="radio"
                    checked={slaughterForm === 'dead_weight'}
                    onChange={() => setSlaughterForm('dead_weight')}
                  />
                  {t('pages.business.deadWeight')}
                </label>
                <label>
                  <input
                    type="radio"
                    checked={slaughterForm === 'live_weight'}
                    onChange={() => setSlaughterForm('live_weight')}
                  />
                  {t('pages.business.liveWeight')}
                </label>
              </div>
            </div>

            <div className="field">
              <div className="title">
                {t('pages.business.hasFasting')}
              </div>
              <div className="content">
                <label>
                  <input
                    type="radio"
                    checked={isFasting}
                    onChange={() => setIsFasting(true)}
                  />
                  {t('pages.business.yes')}
                </label>
                <label>
                  <input
                    type="radio"
                    checked={!isFasting}
                    onChange={() => setIsFasting(false)}
                  />
                  {t('pages.business.no')}
                </label>
              </div>
            </div>

            { isFasting &&
              <div className="field">
                <div className="title">
                  {t('pages.business.fastingHours')}
                </div>
                <div className="content">
                  <input
                    type="number"
                    min="0"
                    max="12"
                    value={hoursFasting}
                    onChange={(e) => setHoursFasting(e.target.value)}
                  />
                </div>
              </div>
            }
          </>
        }

        <div className="field values">
          <div className="title">
            {t('pages.business.values')}
          </div>
          <div className="content">
            <div>
              <input
                type="number"
                placeholder={t('pages.business.placeholder.price')}
                onChange={(e) => setNegotiatedValue(e.target.value)}
              />
              <select
                onChange={(e) => setPaymentMeasure(e.target.value)}
              >
                <option value="fifteen_kilos">{t('pages.business.fifteenKilos')}</option>
                <option value="sacs">{t('pages.business.sacs')}</option>
                <option value="tons">{t('pages.business.tons')}</option>
                <option value="head">{t('pages.business.head')}</option>
              </select>
            </div>
          </div>
        </div>

        <div className="field">
          <div className="content">
            <input
              type="number"
              placeholder={t('pages.business.placeholder.others')}
              onChange={(e) => setOtherValue(e.target.value)}
            />
          </div>
        </div>

        <div className="field total-value">
          <div className="content">
            <label>Total: {calculateTotalValue()} p/{measureTypes.find(type => type.value === paymentMeasure).name}</label>
          </div>
        </div>

        { tagSelected.is_bovine && !tagSelected.is_slaughter &&
          <div className="field">
            <div className="content">
              <input
                type="number"
                placeholder={t('pages.business.placeholder.weight')}
                onChange={(e) => setAliveKg(e.target.value)}
              />
              <input
                type="number"
                placeholder={t('pages.business.placeholder.anmimalsAmount')}
                onChange={(e) => setAnimalsQuantity(e.target.value)}
              />
            </div>
          </div>
        }
        
        { awardsValues.length > 0 &&
          <div className="field">
            <div className="title">
              {t('pages.business.awards')}
            </div>
            <div className="content">
              {
                awardsValues.map(award =>
                  <div>
                    <input
                      type="number"
                      placeholder={award.name}
                      onChange={(e) => handleAwardValues(award.id, e.target.value)}
                    />
                  </div>
                )
              }
            </div>
          </div>
        }

        <div className="field">
          <div className="title">
            {t('pages.business.breedPattern')}
          </div>
          <div className="content">
            <div className="breeds">
              {
                cattleBreeds.map((cattleBreed, index) => (
                  <label>
                    <InputMask
                      mask="999\%"
                      maskChar={' '}
                      value={cattleBreed.cattle_percentage}
                      className="percent-value"
                      onChange={(e) => handleBreedsValue(cattleBreed.breed, e.target.value)}
                    />
                    <input
                      type="checkbox"
                      checked={checkBreeds[index].check}
                      onChange={(e) => handleBreedsCheck(checkBreeds[index].kind, e.target.value)}
                    />
                    {cattleBreed.name}
                    <br/>
                  </label>
                ))
              }
            </div>
          </div>
        </div>

        <div className="field">
          <div className="title">
            {t('pages.business.type')}
          </div>
          <div className="content">
            <label>
              <InputMask
                mask="999\%"
                maskChar={' '}
                value={cattleType[0].type_percentage}
                className="percent-value"
                onChange={(e) => handleCattleType(cattleType[0].kind, e.target.value)}
              />
              <input
                type="checkbox"
                checked={checkCattleType[0].check}
                onChange={(e) => handleCheckCattleType(checkCattleType[0].kind, e.target.value)}
              />
              {t('pages.business.castratedAnimals')}
            </label>
            <br/>
            <label>
              <InputMask
                mask="999\%"
                maskChar={' '}
                value={cattleType[1].type_percentage}
                className="percent-value"
                onChange={(e) => handleCattleType(cattleType[1].kind, e.target.value)}
              />
              <input
                type="checkbox"
                checked={checkCattleType[1].check}
                onChange={(e) => handleCheckCattleType(checkCattleType[1].kind, e.target.value)}
              />
              {t('pages.business.wholeAnimals')}
            </label>
          </div>
        </div>

        <div className="field">
          <div className="title">
            {t('pages.business.termination')}
          </div>
          <div className="content">
            <label>
              <input
                type="radio"
                checked={termination === 'semi_confined'}
                onChange={() => setTermination('semi_confined')}
              />
              {t('pages.business.semiConfined')}
            </label>
            <label>
              <input
                type='radio'
                checked={termination === 'confined'}
                onChange={() => setTermination('confined')}
              />
              {t('pages.business.confined')}
            </label>
            <label>
              <input
                type="radio"
                checked={termination === 'grass_protein'}
                onChange={() => setTermination('grass_protein')}
              />
              {t('pages.business.protein')}
            </label>
            <label>
              <input
                type='radio'
                checked={termination === 'grass'}
                onChange={() => setTermination('grass')}
              />
              {t('pages.business.pasture')}
            </label>
          </div>
        </div>

        <div className="field">
          <div className="title">
            {t('pages.business.paymentType')}
          </div>
          <div className="content">
            <label>
              <input
                type="radio"
                checked={paymentForm === 'in_cash'}
                onChange={() => setPaymentForm('in_cash')}
              />
              {t('pages.business.inCash')}
            </label>
            <label>
              <input
                type='radio'
                checked={paymentForm === 'in_installment'}
                onChange={() => setPaymentForm('in_installment')}
              />
              {t('pages.business.inInstallment')}
            </label>
          </div>
        </div>

        <div className="field">
          <div className="title">
            {t('pages.business.tax')}
          </div>
          <div className="content">
            <label>
              <input
                type="radio"
                checked={taxForm === 'to_charge'}
                onChange={() => setTaxForm('to_charge')}
              />
              {t('pages.business.toCharge')}
            </label>
            <label>
              <input
                type='radio'
                checked={taxForm === 'free'}
                onChange={() => setTaxForm('free')}
              />
              {t('pages.business.free')}
            </label>
            <label>
              <input
                type='radio'
                checked={taxForm === 'free_taxes'}
                onChange={() => setTaxForm('free_taxes')}
              />
              {t('pages.business.taxFree')}
            </label>
          </div>
        </div>

        <div className="field">
          <div className="title">
            {t('pages.business.delivery')}
          </div>
          <div className="content">
            <label>
              <input
                type="radio"
                checked={freightResponsibility === 'buyer'}
                onChange={(e) => setFreightResponsibility('buyer')}
              />
              {t('pages.business.buyer')}
            </label>
            <label>
              <input
                type='radio'
                checked={freightResponsibility === 'seller'}
                onChange={(e) => setFreightResponsibility('seller')}
              />
              {t('pages.business.seller')}
            </label>
          </div>
        </div>

        <div className="field">
          <div className="title">
            {t('pages.business.city')}
          </div>
          <div className="content">
            <Select
              className="select"
              classNamePrefix="select"
              name="color"
              options={citys}
              placeholder={t('pages.business.placeholder.select')}
              noOptionsMessage={() => t('pages.business.placeholder.noOptions')}
              onInputChange={(name) => searchCityByName(name)}
              onChange={(e) => setCityCode(e.value)}
            />
          </div>
        </div>

        { tagSelected.is_slaughter &&
          <div className="field infos">
            <div className="infos-heading">
              {t('pages.business.slaughterReport')}
            </div>
            <div className="content">
              <div className="title">{t('pages.business.slaughterAnimals')}</div>
              <input
                type="number"
                placeholder={t('pages.business.placeholder.amount')}
                value={draftSlaughterQty}
                className="animals-quantity"
                onChange={(e) => setDraftSlaughterQty(e.target.value)}
              />
              <div className="title">{t('pages.business.slaughterDateLabel')}</div>
              <div className="abate-row">
                <input
                  type="date"
                  value={draftSlaughterDate}
                  onChange={(e) => setDraftSlaughterDate(e.target.value)}
                />
                <button
                  type="button"
                  className="btn-abate"
                  onClick={addAbate}
                >
                  {t('pages.business.addSlaughter')}
                </button>
              </div>
              {infoSlaughter.length > 0 && (
                <div className="lista-abates">
                  {infoSlaughter.map((info, index) => (
                    <div className="abate-item" key={`${info.slaughter_date}-${index}`}>
                      <div>
                        <p><strong>{t('pages.business.slaughterItem')}{index + 1}</strong></p>
                        <p>{t('pages.business.animalsQtyLabel')}{info.animals_quantity}</p>
                        <p>{t('pages.business.slaughterDateLabel')}: {formatSlaughterDate(info.slaughter_date)}</p>
                      </div>
                      <button type="button" className="abate-lixo" onClick={() => removeAbate(index)} aria-label="Excluir abate">
                        <FiTrash2 size={18} />
                      </button>
                    </div>
                  ))}
                </div>
              )}
              <div className="title">{t('pages.business.placeholder.observation')}</div>
              <textarea
                placeholder={t('pages.business.placeholder.observation')}
                value={draftSlaughterObs}
                onChange={(e) => setDraftSlaughterObs(e.target.value)}
              />
            </div>
          </div>
        }

        {SHOW_SEND_TO && (
        <div className="field">
          <div className="title">
            {t('pages.business.sendTo')}
          </div>
          <div className="content">
            <Select
              className="select"
              classNamePrefix="select"
              name="color"
              options={reviewers}
              placeholder={t('pages.business.placeholder.select')}
              noOptionsMessage={() => t('pages.business.placeholder.noOptions')}
              onInputChange={(name) => searchReviewer(name)}
              onChange={(e) => setReviewerId(e.value)}
            />
          </div>
        </div>
        )}

        { sending &&
          <div className="message sending">
            <p><strong>{t('pages.business.sending')}</strong></p>
          </div>
        }

        { success &&
          <div className="message success">
            <p><strong>{t('pages.business.success')}</strong></p>
          </div>
        }

        { erros.length > 0 &&
          <div className="message error">
            <p><strong>{t('pages.business.errors.incorrectData')}</strong></p>
            { erros.map(error => <p>- {error} </p>) }
          </div>
        }

        <div className="field">
          <button
            type="submit"
            className="submit"
            disabled={sending || success}
          >
            {sending ? t('pages.business.sendLoading') : t('pages.business.send')}
          </button>
        </div>
      </form>
    </div>
    </FeedLayout>
  );
}